import MovieCard from '@/components/feature/MovieCard';
import SectionHeading from '@/components/base/SectionHeading';
import { movies } from '@/mocks/movies';

export default function LatestMovies() {
  const latest = [...movies].sort((a, b) => b.year - a.year).slice(0, 8);

  return (
    <section className="mx-auto max-w-6xl px-4 md:px-6">
      <SectionHeading
        title="最新影视作品"
        subtitle="最近收录与更新的剧情作品"
        moreText="查看全部"
        moreTo="/category"
      />
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {latest.map((movie, i) => (
          <div key={movie.id} className="animate-card-in" style={{ animationDelay: `${i * 60}ms` }}>
            <MovieCard movie={movie} />
          </div>
        ))}
      </div>
    </section>
  );
}